import React                from 'react';
import PropTypes            from 'prop-types';
import Flux                 from '../../../flux/Flux';
import {getCompleteDataset} from "../../../utils/CommonUtils";

const TILES_PER_PAGE = 30;

function getButtonConfigByActorData(actor) {
    return {
        actorId:                              actor.id,
        actorLink:                            actor.linkVX,
        isActorOnline:                        actor.chat?.online,
        isOnlineMobileVideocall:              actor.isOnlineMobileVideocall,
		isLivePreviewEnabled:                 actor.chat?.features?.livePreview,
        singleC2CChatPrice:                   actor.chat?.prices?.singleC2CChat?.value || 0,
        multiChatPrice:                       actor.chat?.prices?.videoChat?.value || 0,
        prices: {
            freeMessages: 0,
            message: 0,
            single: actor.chat?.prices?.singleChat?.value || 0,
            singlec2c: actor.chat?.prices?.singleC2CChat?.value || 0,
            video: actor.chat?.prices?.videoChat?.value || 0,
            voucherChatMinutes: 0,
            voyeur: actor.chat?.prices?.voyeurChat?.value || 0,
        }
    };
}

function setButtonConfig(actors) {
    const configs = actors.map(actor => getButtonConfigByActorData(actor));
    Flux.Button.setButtonConfig(configs);
}

function withActors(WrappedComponent) {
	class withActors extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				actors: this.props.useCache ? this.getActorsFromStore() : [],
			};

            this.loadActors         = this.loadActors.bind(this);
			this.onActorsLoadChange = this.onActorsLoadChange.bind(this);
			this.getActorsFromStore = this.getActorsFromStore.bind(this);
			this.setActors          = this.setActors.bind(this);

			this.loadMoreBtn = null;
		}

		componentDidMount() {
			Flux.Actors.addActorsDataLoadListener(this.onActorsLoadChange);
			this.loadActors();
		}

		componentDidUpdate(prevProps) {
			if (JSON.stringify(this.props.filter) !== JSON.stringify(prevProps.filter) || JSON.stringify(this.props.offset) !== JSON.stringify(prevProps.offset) || JSON.stringify(this.props.order) !== JSON.stringify(prevProps.order) || prevProps.key !== this.props.key) {
				this.loadActors();
			}
		}

		componentWillUnmount() {
			Flux.Actors.removeActorsDataLoadListener(this.onActorsLoadChange);
		}

		getActorsFromStore() {
			const {filter, order, offset, preset, first} = this.props;
			const actors   = () => Flux.Actors.getActors(filter, order, preset, this.props.id) || [];
			const getTotal = () => Flux.Actors.getActorsTotalCount(filter, order, preset);
			return getCompleteDataset(actors, getTotal, first, offset) || [];
		}

		onActorsLoadChange() {
			const {filter, order, preset} = this.props;
			const isLoading = Flux.Actors.isActorsDataLoading(filter, order, preset);
			if (!isLoading) {
				const actors = this.getActorsFromStore();
				this.setActors(actors);
			}
		}

        getExcludedIds() {
            if (this.props.offset > 0) {
                return [...this.state.actors].map((actor) => actor.id);
            }
            return [];
        }

        loadActors() {
			const actors = this.props.useCache ? this.getActorsFromStore() : [];
			if (actors.length < 1) {
				Flux.Actors.loadActors(
					this.props.first,
					this.props.last,
					this.props.offset,
					this.props.order,
					this.props.filter,
					this.props.preset,
					this.props.id,
					this.props.isV3,
					this.props.onlineFilter);
			} else {
				this.setActors(actors);
			}
        }

		setActors(actors) {
			if (actors.length < 1) {
				//return;
			}
            setButtonConfig(actors);
			if(this.props.isLoadMore) {
				this.setState({actors: [...this.state.actors, ...actors]});
			} else {
				this.setState({actors});
			}
		}

		render() {
			let data = this.state.actors;

			if (this.props.maxTiles > 0) {
				data = [...data.slice(0, this.props.maxTiles)];
			}

			if (this.props.removeSedcard) {
				data = data.map((actor) => ({
					...actor,
					sedcard: [], //clear sedcard to only show profile picture
				}));
			}
			return <WrappedComponent {...this.state} {...this.props} tileData={data} />;
		}
	}

	withActors.propTypes    = {
		filter: PropTypes.shape({
			ids:      PropTypes.arrayOf(
				PropTypes.number,
			),
			excludedIds:      PropTypes.arrayOf(
				PropTypes.number,
			),
            online:         PropTypes.bool,
            tvLiveshow:     PropTypes.bool,
            tvProduction:   PropTypes.bool,
            conversionChat: PropTypes.bool,
            guestModel:     PropTypes.bool,
            vxselect:       PropTypes.bool,
            vip30:          PropTypes.bool,
            age:            PropTypes.shape({
                lt: PropTypes.number,
                gt: PropTypes.number,
            }),
            internal:       PropTypes.bool,
            gender:         PropTypes.arrayOf(
                PropTypes.string
            ),
            hasAvatarPicture: PropTypes.bool,
            collectionId:     PropTypes.string,
            collectionOrigId: PropTypes.number,
		}),
		order:  PropTypes.oneOf([
			Flux.Constants.Vxql.Actors.Order.GUEST_PREFERENCES,
			Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING,
			Flux.Constants.Vxql.Actors.Order.RANKING,
			Flux.Constants.Vxql.Actors.Order.DATE,
		]),
		offset:        PropTypes.number,
		first:         PropTypes.number,
		last:          PropTypes.number,
		total:         PropTypes.number,
        id:            PropTypes.string,
        preset:        PropTypes.string,
		removeSedcard: PropTypes.bool,
		isLoadMore:    PropTypes.bool,
		useCache:      PropTypes.bool,
		isMobile:      PropTypes.bool,
		maxTiles:      PropTypes.number,
		isV3:          PropTypes.bool,
		onlineFilter:  PropTypes.object,
        key:           PropTypes.number,
	};
	withActors.defaultProps = {
		filter: {
            gender: []
		},
		order:  Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING,
		offset: 0,
		first:  TILES_PER_PAGE,
		preset: '',
		last:   null,
        id:     Math.random().toString(),
		removeSedcard: false,
		isLoadMore: false,
		useCache:   true,
		total:      0,
		isMobile:   false,
		maxTiles:   0,
		isV3:       false,
		onlineFilter: {},
	};

	return withActors;
}

export default withActors;
